import React, { useState } from 'react';
import { Menu, MenuItem, CircularProgress } from '@mui/material';
import { ContentCopy, AddAlarm, FileDownload } from '@mui/icons-material';
import { showSuccessNotification, showErrorNotification } from '@core/utils/apiErrorHandler';
import { IFilter } from '@shared/hooks/useFilters';
import { OfferListFilters } from '@modules/offers/types';
import { downloadOffersExcel } from '@modules/offers/services';

type OfferFilterType = IFilter<OfferListFilters>;

interface ActionsMenuProps {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    canAdd: boolean;
    canUpdate: boolean;
    onBulkCreate: () => void;
    onBulkSchedule: () => void;
    filters: OfferFilterType;
}

const MoreActionsMenu: React.FC<ActionsMenuProps> = ({
    anchorEl,
    onClose,
    canAdd,
    canUpdate,
    onBulkCreate,
    onBulkSchedule,
    filters,
}) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExportExcel = async () => {
        setIsExporting(true);

        try {
            await downloadOffersExcel(filters);
            showSuccessNotification('Excel file downloaded successfully');
            onClose();
        } catch (error) {
            showErrorNotification(error instanceof Error ? error.message : 'Failed to download Excel file');
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {canAdd && (
                <MenuItem
                    onClick={() => {
                        onClose();
                        onBulkCreate();
                    }}
                >
                    <ContentCopy fontSize="small" style={{ marginRight: 8 }} /> Bulk Create
                </MenuItem>
            )}
            {canUpdate && (
                <MenuItem
                    onClick={() => {
                        onClose();
                        onBulkSchedule();
                    }}
                >
                    <AddAlarm fontSize="small" style={{ marginRight: 8 }} /> Bulk Schedule
                </MenuItem>
            )}
            <MenuItem onClick={handleExportExcel} disabled={isExporting}>
                {isExporting ? (
                    <CircularProgress size={18} style={{ marginRight: 8 }} />
                ) : (
                    <FileDownload fontSize="small" style={{ marginRight: 8 }} />
                )}
                Export Excel
            </MenuItem>
        </Menu>
    );
};

export default MoreActionsMenu;
